const KEYWORDS = {
    home: [
        "Enterprise Solutions",
        "Enterprise level ERP solution",
        "Gold purchasing process",
        "Gold price determination process",
        "Maritime reports",
        "Architectural design and development support",
        "Technology Consulting",
        "Inventory & Logistics Solution",
        "Procurement process",
        "Stock Tracking",
        "prevent understocking and overstocking",
        "Ecommerce Marketplace",
        "Marketing Aggregator Platform",
        "Technical Development & Enhancements",
        "Store location search algorithm",
        "Manage counterfeit currency",
        "Air Marine Cargo Tracking Software",
        "Marine cargo services",
        "Enterprise level application development",
        "Thought leadership and technology consulting",
        "Legacy application empowerment",
        "Modernize legacy application",
        "Legacy application support",
        "Support in VB.Net, VC++",
        "C# .Net Framework",
        ".Net Core",
        "MS SQL Server",
        "MySQL",
        "MS Access",
        "Application Integration",
        "Software integration services",
        "Seamlessly integrate software systems",
        "Application maintenance and support",
        ".Net Core 8.0",
        "Node.js",
        "Postgres SQL",
        "Mongo DB SQL",
        "Angular",
        "React.js",
        "Microsoft Azure / AWS Infrastructure",
        "Microservice Architecture",
        "Kubernetes Service",
        "AI/ML",
        "Google Gemini",
        "Open AI GPT",
        "Message Queue",
        "Redis",
        "Elastic search",
        "Business with distributed data",
        "Business with distributed data across locations",
        "Difficult to collate business data",
        "Migrate to Newgen technologies",
        "Data Migration Tool",
        "Realtime Data synchronisation tool",
        "Data synchronisation tool",
        "Data Sync",
        "Business with distributed data across locations",
        "Solution for distributed and offline data",
        "Seamless synchronize distributed offline data",
        "Data Collation and Reporting Tool",
        "Seamless data collation",
        "Data Migration Tool",
        "Data Transition",
        "Seamless data transition",
        "Application Development",
        "Business-Focussed Tech Solutions",
        "Digital Transformation",
        "Technology Leadership",
        "System Support & Enhancement",
        "System Integration",
        "Development Resource Staffing",
        "Quality Assurance Services",
        "Services and solutions for global clients",
        "Flexible resource model",
        "Staffing",
        "Task based resourcing",
        "Artificial Intelligence",
        "Machine Learning",
        "Predictive Analytics",
        "Natural Language Processing NLP",
        "Computer Vision",
        "Image Analytics",
        "LLM RAG",
        "LLM Fine Tuning",
        "Audio AI",
        "Deep Reinforcement Learning",
        "FinTech",
        "NBFC",
        "FinTech & NBFC",
        "FinTech Solutions",
        "NBFC Solutions",
        "NBFC Domain",
        "Digital Lending",
        "Payments",
        "Gold Purchase Loan Management",
        "Financial Management",
        "Customer Acquisition & Onboarding",
        "Payments & Collections"
    ],
    fintech: [
        "FinTech",
        "NBFC",
        "FinTech & NBFC",
        "FinTech Solutions",
        "NBFC Solutions",
        "NBFC Domain",
        "Loan Origination System",
        "Loan Management System",
        "LOS",
        "LMS",
        "Core Banking Solutions",
        "API Integration",
        "B2B & B2C Gold Purchase",
        "Auction / Retail Purchase of Gold",
        "Purchase of gold and selling to refiners",
        "Central Customer Repository",
        "Digital KYC",
        "AI based Credit scoring",
        "NACH",
        "UPI Autopay",
        "POS Integration",
        "Regulatory Reporting",
        "Core Transaction System Development",
        "Card & Payment Processing Expertise",
        "Card Lifecycle Management",
        "RiskNet Integration",
        "Falcon Integration",
        "ISO 8583",
        "Smart Card Wallet Systems"
    ],

    ai: [
        "Artificial Intelligence",
        "Machine Learning",
        "Predictive Analytics",
        "ML Models for forecasting",
        "Natural Language Processing",
        "NLP",
        "Computer & Image Analytics",
        "Video Analytics",
        "LLM Fine Tuning",
        "LLM",
        "RAG",
        "Speech & Audio AI",
        "Deep Reinforcement Learning",
        "AI agents for Autonomous decision making",
        "GANs",
        "Self supervised learning",
        "Deep generative models",
        "LLM powered Intelligent Chatbot",
        "Voice to text",
        "Predictive Risk Monitoring Platform",
        "Local LLM Deployment"
    ],
      
    smartsync: [
        "Business with distributed data",
        "Business with distributed data across locations",
        "Difficult to collate business data",
        "Migrate to Newgen technologies",
        "Data Migration Tool",
        "Realtime Data synchronisation tool",
        "Data synchronisation tool",
        "Data Sync",
        "Solution for distributed and offline data",
        "Seamless synchronize distributed offline data",
        "Data Collation and Reporting Tool",
        "Seamless data collation",
        "Data Transition",
        "Seamless data transition"
    ],

    contactus: [
        "Virtuosoft Technologies Private Limited",
        "Virtuosoft Technologies",
        "Virtuosoft Trivandrum",
        "Virtuosoft Technopark",
        "Virtuosoft Technopark Trivandrum",
        "Contact Virtuosoft Technopark Trivandrum"
      ]
      



};
  
export default KEYWORDS;